"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForbiddenModal = exports.NotFoundModal = void 0;
const NotFoundModal_1 = __importDefault(require("./NotFoundModal"));
exports.NotFoundModal = NotFoundModal_1.default;
const ForbiddenModal_1 = __importDefault(require("./ForbiddenModal"));
exports.ForbiddenModal = ForbiddenModal_1.default;
